import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Divider } from '@mui/material';

import SchoolListItem from './SchoolListItem';

export default function SchoolsListGrid(props) {
    const mySettings = props.settings
    const sidebarSettings = props.sidebarSettings
    const schools = sidebarSettings.schools

    return (
        <TableContainer>
            <Divider />
            <Table aria-label="simple table" size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ borderBottom: "none" }}>School</TableCell>
                        <TableCell sx={{ borderBottom: "none" }}>Swaps</TableCell>
                        <TableCell sx={{ borderBottom: "none" }} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {schools ? (Object.keys(schools).map((school, index) => (
                        <SchoolListItem school={schools[school]} settings={mySettings} key={index} sidebarSettings={sidebarSettings} />
                    ))) : null}
                </TableBody>
            </Table>
        </TableContainer>
    )
}